import { instanceToPlain } from "class-transformer";
import VueI18n from "vue-i18n";

import { BasePeriodCondition } from "./BaseCondition/BasePeriodCondition";

export abstract class IntervalCondition extends BasePeriodCondition {
  values: Array<string> = []

  async validate() {
    return this.values.every(v => v) && this.values.length === 2
  }

  getModel() {
    return instanceToPlain({
      type: this.type,
      values: this.values
    })
  }

  getBeautifiedValues(i18n: VueI18n) {
    return this.values
      .reduce<Array<string>>((acc, _, currentIndex, array) => {
        if (currentIndex % 2 === 0) {
          const interval = array.slice(currentIndex, currentIndex + 2)

          acc.push(i18n.t("period_conditions_interval_from_to", [ interval[0], interval[1] ]).toString());
        }

        return acc;
      }, [])
  }

  addValue(newCondition: IntervalCondition) {
    this.values.push(...newCondition.values)
  }

  removeValue(condition: BasePeriodCondition, index?: number) {
    if (index !== undefined) {
      const valueIndex = index * 2

      this.values.splice(valueIndex, 2)
    }
  }

  isEmpty(): boolean {
    return !this.values.length
  }
}
